import React from 'react'

import Search from '../../../molecules/Search'
import FilterMenu from './FilterMenu'
import RoundButton from '../../../atoms/RoundButton'
import NewConversationModal from '../NewConversation'
import AddIcon from '../../../atoms/Icons/AddIcon'

import useStyles from './styles'

const FiltersV2 = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const [open, setOpen] = React.useState(false)

  const classes = useStyles()

  const handleNewChatClick = React.useCallback(() => {
    setOpen(true)
  }, [])

  const handleCloseModal = React.useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <React.Fragment>
      <div ref={anchorRef} className={classes.root}>
        <Search
          placeholder='Search...'
          maxLength={20}
          className={classes.search}
          loading={false}
        />

        <FilterMenu anchor={anchorRef.current} />

        <RoundButton className={classes.button} onClick={handleNewChatClick}>
          <AddIcon />
        </RoundButton>
      </div>
      {open && <NewConversationModal onClose={handleCloseModal} />}
    </React.Fragment>
  )
}
export default FiltersV2
